import angular from "angular";

import './screen-pages.component.scss';

export default {
  template: require('./screen-pages.component.html'),
  transclude: {
    contents: "?vuiScreenPagesContents"
  },
  bindings: {
    pagesCount: "<vuiCount",
    pager: "<vuiPager",
    onChange: '<vuiChange'
  },
  controller: function ($element, $timeout, $document, $window, $handlers) {
    'ngInject';

    const self = this;

    self.$onInit = () => {
      const pager = {
        current: 0,
        next: () => {
          if (self.pager.current < self.pagesCount - 1) {
            self.pager.current++
          }

          self.pager.slide();
        },
        prev: () => {
          if (self.pager.current > 0) {
            self.pager.current--;
          }

          self.pager.slide();
        },
        setStep: step => {
          self.pager.current = step;
          self.pager.slide();
        },
        slide: (skipScroll) => {
          if (self.content) {
            self.content.style.left = -(self.pager.current * self.stepContent.getBoundingClientRect().width) + 'px';
          }
          $timeout(() => self.content.style.left = -(self.pager.current * self.stepContent.getBoundingClientRect().width) + 'px', 260);
          changeStepsState();
          if (!skipScroll) {
            scrollTo(document.querySelector('.vui-content'), 0, 250);
          }
        }
      };

      $timeout(() => {
        const contents = $element.children().children().children().children();
        const contentList = [];
        for (let i = 0; i < contents.length; i++) {
          contentList.push(angular.element(contents[i]).children())
        }
        self.contents = contentList;

        self.content = $element.children().children()[0].children[0];
        self.stepContent = self.content.children[0];

        pager.slide();
      });

      self.onChange(pager);

      $handlers.subscribe($handlers.TOGGLE_SIDE_MENU, onResize);

      $document.on('resize', onResize);
      angular.element($window).bind('resize', onResize);
      $document.on('$destroy', () => {
        $document.off('resize', onResize);
        angular.element($window).unbind('resize', onResize);
        $handlers.unsubscribe($handlers.TOGGLE_SIDE_MENU, onResize);
      });
    }

    const scrollTo = (element, to, duration) => {
      if (duration <= 0) return;
      const difference = to - element.scrollTop;
      const perTick = difference / duration * 10;

      setTimeout(() => {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) {
          return;
        }
        scrollTo(element, to, duration - 10);
      }, 10);
    }

    const changeStepsState = () => {
      for (let i = 0; i < self.contents.length; i++) {
        const content = self.contents[i];

        if (i < self.pager.current) {
          $timeout(() => content.removeClass('active'), 250);
        } else if (i === self.pager.current) {
          content.addClass('active');
        } else {
          $timeout(() => content.removeClass('active'), 250);
        }
      }
    }

    const onResize = () => {
      self.pager.slide(true);
    }

  }
};
